module.exports = {
    next_initialize() {
        const injectAxiosExtension = require('./lib/axios/injectAxiosExtension');
        const axiosUrlParams = require('./lib/axios/extensions/url-params');
        const axiosCompress = require('./lib/axios/extensions/compress');
        injectAxiosExtension(axiosUrlParams);
        injectAxiosExtension(axiosCompress);
    }
}